import React from 'react';
// import _ from 'lodash';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

import general from '../../modulos/general';

const ImprDC = ({listFactCl, list2, empresa}) => {
    // console.log(listFactCl)
    // console.log(list2)
    // console.log(list)
    // console.log(cliente)
    // console.log(empresa)

      //GENERAR PDF
      let doc = new jsPDF({orientation: 'p', unit: 'mm', format: 'letter'})
      // let widthDoc = (doc.internal.pageSize.width)
      // let heightDoc = (doc.internal.pageSize.height)
      // widthDoc para letter es 215.89999999999998 => se aprox a 216
      // heightDoc para letter es 279.4 => se aprox a 279
      let contList = 0

      let nomB1 = "", nomB2 = ""
      let modeloFactura = empresa.modeloFactura
// console.log(modeloFactura)
      listFactCl.forEach((elemento1, i) => {
        // console.log(elemento1)
        contList += 1

        let elemento = elemento1.listFact
        let codBarras = elemento1.listFact.codBarras

//OJOOO si la fra no es del proc fact => en codProcFact viene el id del rango
        // let indexSearchR = -1
        // let indexSearchP = list2.findIndex( proceso => proceso.codProcFact===elemento.codProcFact )
        // if(indexSearchP===-1){
        //   indexSearchR = list.findIndex( rango => rango._id==elemento.codProcFact )
        //   if(indexSearchR===-1){
        //     if(elemento.codProcFact!=="ANULADA"){
        //       // alert(`La factura ${elemento.numeroFra} tiene asociado un proceso de facturación que no existe`)
        //       console.log("alert ", elemento.codProcFact, elemento.numeroFra, elemento.contrato)
        //       indexSearchR = list.length-1
        //     }
        //   }
        // }else{
        //   indexSearchR = list.findIndex( rango => rango._id==list2[indexSearchP].idRangoFact )
        // }
        // let rangoFra = list[indexSearchR]
      
      let linea1Obs = "PAGUESE DE INMEDIATO"
    //   let linea2Obs = rangoFra.observaciones
    //   let rangoIniFin = `${rangoFra.factInicial} - ${rangoFra.factFinal}`
    //   let linea3Obs = `RESPONSABLE DE IVA - Formulario ${rangoFra.numResolucion} . Autorización de Numeración ${rangoIniFin}`

      let linea1DNN = elemento.direccion.substr(0, 40)
      
      let linea2DNN = elemento.nombreCiudad?elemento.nombreCiudad:""
      linea2DNN += elemento.nombreBarrio?" - " + elemento.nombreBarrio:""
      linea2DNN = linea2DNN.substr(0, 40)
      let linea2DNN_B = ""
      linea2DNN_B = elemento.nombreBarrio?elemento.nombreBarrio:""
      linea2DNN_B = linea2DNN_B.substr(0, 40)

      if(elemento.nombreBarrio){
        if(contList===1){
          nomB1 = elemento.nombreBarrio
        }else{
          nomB2 = elemento.nombreBarrio
        }
      }

      let nombreCli = `${elemento.nombreCliente} ${elemento.apellidoCliente}`
      nombreCli = nombreCli.substr(0, 40)
      
      let movColecc = [], movColeccOrd = []

      let argsUpd = []
      argsUpd = ({descripcion: `Saldo pendiente por pagar`, valor: elemento.saldoPendiente})    
      movColeccOrd.push(argsUpd)

      // console.log(movColeccOrd)
      movColeccOrd.forEach((elemento1, ii) => {
        let argsUpd = []
        argsUpd.push(elemento1.descripcion)
        argsUpd.push('$' + general.formatNum(elemento1.valor.toString()))
      
        movColecc.push(argsUpd)
      })
// console.log(movColecc)
//IMPRIMIR DOCUMENTO DE COBRO MODELO 1 => BUENAVENTURA
// console.log(modeloFactura)
      if(modeloFactura==="1"){
        var imgSource = new Image();
        imgSource.src = "images/logocliente.jpeg";
        doc.convertStringToImageData(imgSource)
        doc.addImage(imgSource, 'PNG', 12, 12, 66, 20, 'logo');
      
        doc.setFontSize(10);
        doc.setFontType("bold");
        doc.setFontStyle("italic");
        doc.text(empresa.empresaRazonSocial, 40, 33, 'center')

        doc.setFontSize(8);
        doc.setFontType("normal");
        doc.text(`NIT. ${empresa.empresaNit}`, 40, 37, 'center')
        doc.text(`${empresa.empresaDir} ${empresa.empresaTel}`, 40, 40, 'center')

        doc.setDrawColor("green")
        doc.lines([[70,0],[0,32],[0-70,0]], 80,10, [1,1], 'S', true)
        doc.line(80, 18, 150, 18)
        doc.line(80, 26, 150, 26)
        doc.line(80, 34, 150, 34)
        doc.setFontSize(12);
        doc.setFillColor("green")
        doc.lines([[35,0],[0,8],[0-35,0]], 80,10, [1,1], 'F', true)
        doc.setTextColor("white")
        doc.setFontType("bold");
        doc.text("CONTRATO:", 82, 15)
        doc.setFontType("bold");
        doc.setTextColor("green")
        doc.text(elemento.contrato, 132, 15, 'center')
        doc.text(`DOCUMENTO DE COBRO`, 154, 15)
        doc.setFontSize(6);
        doc.setTextColor("black")
        doc.text("CLIENTE", 82, 21)
        doc.text("DIRECCION", 82, 29)
        doc.text("MUNICIPIO - BARRIO", 82, 37)
        doc.text("FECHA DE EMISION", 154, 21)
        doc.text("TOTAL A PAGAR", 154, 29)
        doc.text("PAGUE HASTA", 154, 37)
        doc.setFontSize(8);
        doc.setFontType("normal");
        doc.text(nombreCli, 82, 25)
        doc.text(linea1DNN, 82, 33)
        doc.text(linea2DNN, 82, 41)
        doc.text(`${elemento.fechaMov.substr(0, 10)}`, 154, 25)
        doc.text('$' + general.formatNum(elemento.saldoPendiente.toString()), 154, 33)
        // if(fraProcFact){
          // doc.text(`${list2[indexSearchP].fechaFact.substr(0, 10)}`, 154, 25)
          // doc.text(`${list2[indexSearchP].mes}`, 154, 33)
          doc.text(`INMEDIATO`, 154, 41)
        // }else{

        // }
      
        doc.setFillColor("blue")

        doc.lines([[140,0],[0,7],[0-140,0]], 10, 44, [1,1], 'F', true)
        // doc.lines([[196,0],[0,7],[0-196,0]], 10, 44, [1,1], 'F', true)

        doc.setFontSize(10);
        doc.setTextColor("white")
        doc.setFontType("bold");
        // if(fraProcFact){
          doc.text("PAGUE HASTA:", 17, 49)
          doc.text(`INMEDIATO`, 56, 49, 'center')
        // }
        doc.text("TOTAL A PAGAR:", 82, 49)
        doc.setLineWidth(1)
        doc.ellipse(125, 47.45, 12, 4)
        doc.setLineWidth(0)
        doc.text('$' + general.formatNum(elemento.saldoPendiente.toString()), 126, 49, 'center')
      
        doc.lines([[54,0],[0,32],[0-54,0]], 152,10, [1,1], 'S', true)
        doc.line(152, 18, 206, 18)
        doc.line(152, 26, 206, 26)
        doc.line(152, 34, 206, 34)
      
        // let observFra = ""
        // if(fraProcFact){
          // observFra = doc.splitTextToSize(list2[indexSearchP].observaciones, 50, 2, 2)
        // }
        doc.setFontSize(10);
        doc.setFillColor("green")

        doc.lines([[54,0],[0,7],[0-54,0]], 152, 44, [1,1], 'F', true)

        doc.setTextColor("white")
        doc.setFontType("bold");


        // doc.lines([[196,0],[0,120],[0-196,0]], 10, 54, [1,1], 'S', true)
        doc.lines([[140,0],[0,120],[0-140,0]], 10, 54, [1,1], 'S', true)

        doc.text("IMPORTANTE:", 177, 49, 'center')
        doc.setDrawColor("black")
        doc.lines([[54,0],[0,120],[0-54,0]], 152, 54, [1,1], 'S', true)

        // var imgSource2 = new Image();
        // imgSource2.src = "images/logoclienteder.jpeg";
        // doc.convertStringToImageData(imgSource2)
        // //153= left, 55 = top, 52 = width, 117 = height
        // doc.addImage(imgSource2, 'PNG', 153, 55, 52, 117, 'publicidadder');

        let textoder = ""
        // let textoder = `  Presentación de servicios

        // 1. Consultorio externo
        //    Manejo integral farmacológica y
        //    psicoterapéutica, contando con
        //    aproximadamente de 40 minutos por
        //    paciente realizando así:
        
        //     a. Psiquiatría general
        
        //        i. Valoración inicial
        //        ii. Intervención en crisis
        //        iii. Diagnostico por ejes CE10 y DSM
        //        iv. Tratamiento farmacológico
        //        v. Seguimiento del paciente
        
        // 2. Gerontopsiquiatria
        //    Prevención, diagnostico y tratamiento de los
        //    trastornos psíquicos de los adultos mayores,
        //    así como de fomentar la longevidad.
        
        // 3. Tratamiento de adicciones
        //    Manejo de trastornos relacionados con el
        //    consumo de alcohol, opiáceos, tabaco y
        //    otras sustancias psicoactivas.
        
        // 4. Psicoterapia familiar con orientación cognitiva
        //    conductual
        //    Identificación de roles, resolución de conflictos
        //    para mantener el equilibrio y la continuidad del
        //    proyecto familiar.
        
        // 5. Terapia grupal
        //    Interacción paciente-paciente,
        //    paciente-terapeuta,
        //    con el fin de realizar cambios en las
        //    conductas disfuncionales y estimulación
        //    del crecimiento y desarrollo de la
        //    personalidad.
        
        // Dra. María Fernanda Ferrer Orozco
        // Médico Psiquiatra
        // CENTRO MEDICO DEL PACIFICO 4to PISO
        // CONSULTORIO 305
        // CEL: 317 624 7128
        // Email: mferrer.md@gmail.com`
        
        doc.setTextColor("black")
        doc.setFontSize(6);
        doc.setFontType("normal");

        textoder = doc.splitTextToSize(textoder, 50, 2, 2)
        doc.text(textoder, 154, 58, 'left')

//POR AHORA NO SE IMPRIME PORQUE NO TIENE FRA => IMPRIME CONTRATO Y PUEDE NO SER NUMERICO
        // let imgSourceCB = new Image();
        // imgSourceCB.src = codBarras;
        // doc.convertStringToImageData(imgSourceCB)
        // doc.addImage(imgSourceCB, 'PNG', 55, 154, 50, 14);

        doc.setFontSize(8);

        doc.lines([[196,0],[0,20],[0-196,0]], 10, 176, [1,1], 'S', true)
        doc.text(linea1Obs, 108, 187, 'center')
        doc.setLineWidth(0)

        var imgSource3 = new Image();
        imgSource3.src = "images/logoclienteinf.jpeg";
        doc.convertStringToImageData(imgSource3)
        //10 = left, 200 = top, 196 = width, 62 = height
        doc.addImage(imgSource3, 'PNG', 10, 200, 196, 62, 'publicidadinf');

        let foot = []
        // if(fraProcFact){
          // foot = [["TOTAL A PAGAR", '$' + general.formatNum(elemento.saldoPendiente.toString())]]
          foot = [["TOTAL A PAGAR", {content: '$' + general.formatNum(elemento.saldoPendiente.toString()), styles: {halign: "right"}}]]
          // }else{
        //   foot = [["TOTAL FACTURADO", '$' + general.formatNum(elemento.saldoPendiente.toString())],
        //   ["TOTAL A PAGAR", '$' + general.formatNum(elemento.saldoPendiente.toString())]]
        // }

        doc.autoTable({startY: 54,
          tableLineColor: "black",
          tableLineWidth: 0.1,
          styles: {
            // font: 'Calibri',
            fontSize: 9,
            lineColor: "black",
            lineWidth: 0.1
          },
          headStyles: {
            fillColor: "#bdc3c7",
            textColor: "black",
            fontSize: 9
          },
          bodyStyles: {
            fillColor: "#E9E4F0",
            textColor: "black"
          },
          columnStyles: {
            1: {halign: "right"}
          },
          alternateRowStyles: {
            fillColor: "white",
            textColor: "black"
          },
          footStyles: {
            fillColor: "#bdc3c7",
            textColor: "black",
            fontSize: 9
          },
          head: [["Concepto", {content: "Valor", styles: {halign: "right"}}]],
          body: movColecc,
          foot: foot,
          margin: {top: 0, left: 10, right: 66},})
          // margin: {top: 0, left: 10, right: 10},})
        }
        //FIN IMPRIMIR DOCUMENTO DE COBRO MODELO 1 => BUENAVENTURA
        //IMPRIMIR DOCUMENTO DE COBRO MODELO 2 => MANIZALES
        if(modeloFactura==="2"){
          // let fechaHoy = new Date()
          // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
          let fechaHoy = elemento.fechaMov.substr(0, 10)

          doc.setTextColor("black")
          doc.setFontSize(8);
          doc.setFontType("normal");

          doc.text(fechaHoy, 105, 47)
          doc.text(elemento.contrato, 150, 47, 'center')
          doc.text(elemento.numeroDoc, 180, 47, 'center')

          doc.setFontSize(7);
          doc.text("Nombre:", 100, 61)
          doc.text(nombreCli, 117, 61)
          // doc.text("Mes facturado:", 174, 64)
          // doc.text(`${elemento.agno}-${elemento.mes}`, 192, 64)

          doc.text("Dirección:", 100, 65)
          doc.text(linea1DNN, 117, 65)
          doc.text(linea2DNN, 117, 68)

          // console.log(elemento.valorFacturado)
          let foot = []
          // if(fraProcFact){
          //   foot = [
            foot = [["TOTAL A PAGAR", {content: '$' + general.formatNum(elemento.saldoPendiente.toString()), styles: {halign: "right"}}]]
          //   ]
          // }else{
          //   foot = [[]]
          // }

          doc.autoTable({startY: 89,
            // tableLineColor: "white",
            // tableLineWidth: 0,
            styles: {
              // font: 'Calibri',
              fontSize: 8,
              lineColor: "white",
              // lineWidth: 0.1,
            },
            bodyStyles: {
              fillColor: "white",
              textColor: "black",
            },
            columnStyles: {
              1: {halign: "right"}
            },
            alternateRowStyles: {
              fillColor: "white",
              textColor: "black",
            },
            footStyles: {
              fillColor: "white",
              textColor: "black",
              fontSize: 8,
              fontStyle: "normal"
            },
            body: movColecc,
            foot: foot,
            margin: {top: 0, left: 98, right: 18},
          })

          doc.setFontSize(10);
          doc.text(`${linea1Obs}`, 120, 132)
          doc.text('$' + general.formatNum(elemento.saldoPendiente.toString()), 187, 132, 'center')

          doc.setFontSize(7);

          // console.log(elemento.valorFacturado)
          // foot = []
          // foot = [["TOTAL A PAGAR", {content: '$' + general.formatNum(elemento.saldoPendiente.toString()), styles: {halign: "right"}}]]

          // doc.autoTable({startY: 150,
          //   // tableLineColor: "white",
          //   // tableLineWidth: 0,
          //   styles: {
          //     // font: 'Calibri',
          //     fontSize: 8,
          //     lineColor: "white",
          //     // lineWidth: 0.1,
          //   },
          //   headStyles: {
          //     fillColor: "white",
          //     textColor: "black",
          //     fontSize: 8
          //   },
          //   bodyStyles: {
          //     fillColor: "white",
          //     textColor: "black",
          //   },
          //   columnStyles: {
          //     1: {halign: "right"}
          //   },
          //   alternateRowStyles: {
          //     fillColor: "white",
          //     textColor: "black",
          //   },
          //   footStyles: {
          //     fillColor: "white",
          //     textColor: "black",
          //     fontSize: 8,
          //     fontStyle: "normal"
          //   },
          //   head: [["CONCEPTO", {content: "VALOR", styles: {halign: "right"}}]],
          //   body: movColecc,
          //   foot: foot,
          //   margin: {top: 0, left: 98, right: 18},
          // })

          // let observFra = ""
          // // if(fraProcFact){
          //   observFra = doc.splitTextToSize("TEVENET NOTICIAS Lunes a Viernes 1 p.m. Canal 2", 180, 2, 2)
          // // }
          // doc.text(observFra, 155, 208.4, 'center')
          // doc.setTextColor("black")
          // doc.setLineWidth(0)

          let imgSourceCB = new Image();
          imgSourceCB.src = codBarras;
          doc.convertStringToImageData(imgSourceCB)
          // 11=Left, 156=Top, 138=Width, 14=Height
          // doc.addImage(imgSourceCB, 'PNG', 11, 156, 138, 14);
          // doc.addImage(imgSourceCB, 'PNG', 11, 148, 138, 24);
          // doc.addImage(imgSourceCB, 'PNG', 71, 210, 138, 24);
          doc.addImage(imgSourceCB, 'PNG', 8, 107, 80, 16);
          doc.addImage(imgSourceCB, 'PNG', 8, 255, 80, 16);

          doc.text("Nombre:", 105, 258)
          doc.text(nombreCli, 120, 258)
          doc.text("Dirección:", 105, 262)
          doc.text(linea1DNN, 120, 262)
          doc.text(linea2DNN, 120, 265)
          doc.text("Contrato:", 105, 269)
          doc.text(elemento.contrato, 120, 269)


          doc.setFontSize(10);
          doc.text('$' + general.formatNum(elemento.saldoPendiente.toString()), 195, 265, 'center')
          doc.setFontSize(7);
        }
        //FIN IMPRIMIR DOCUMENTO DE COBRO MODELO 2 => MANIZALES
        //IMPRIMIR DOCUMENTO DE COBRO MODELO 3 => CABLECAUCA
        if(modeloFactura==="3"){
          // let fechaHoy = new Date()
          // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
          let fechaHoy = elemento.fechaMov.substr(0, 10)

          doc.setTextColor("black")
          doc.setFontSize(8);
          doc.setFontType("normal");

          doc.text(fechaHoy, 105, 42)
          doc.text(elemento.contrato, 150, 42, 'center')
          doc.text(elemento.numeroDoc, 180, 42, 'center')

          doc.setFontSize(7);
          doc.text("Suscriptor:", 100, 56)
          doc.text(nombreCli, 117, 56)
          // doc.text("Mes facturado:", 174, 64)
          // doc.text(`${elemento.agno}-${elemento.mes}`, 192, 64)

          doc.text("Dirección:", 100, 60)
          doc.text(linea1DNN, 117, 60)
          doc.text("Barrio:", 100, 64)
          doc.text(linea2DNN_B, 117, 64)

          // console.log(elemento.valorFacturado)
          let foot = []
          // if(fraProcFact){
          //   foot = [
            foot = [["TOTAL A PAGAR", {content: '$' + general.formatNum(elemento.saldoPendiente.toString()), styles: {halign: "right"}}]]
          //   ]
          // }else{
          //   foot = [[]]
          // }

          doc.autoTable({startY: 89,
            // tableLineColor: "white",
            // tableLineWidth: 0,
            styles: {
              // font: 'Calibri',
              fontSize: 8,
              lineColor: "white",
              // lineWidth: 0.1,
            },
            bodyStyles: {
              fillColor: "white",
              textColor: "black",
            },
            columnStyles: {
              1: {halign: "right"}
            },
            alternateRowStyles: {
              fillColor: "white",
              textColor: "black",
            },
            footStyles: {
              fillColor: "white",
              textColor: "black",
              fontSize: 8,
              fontStyle: "normal"
            },
            body: movColecc,
            foot: foot,
            margin: {top: 0, left: 98, right: 18},
          })

          doc.setFontSize(10);
          doc.text(`${linea1Obs}`, 120, 132)
          doc.text('$' + general.formatNum(elemento.saldoPendiente.toString()), 187, 132, 'center')

          doc.setFontSize(7);

          // console.log(elemento.valorFacturado)
          // foot = []
          // foot = [["TOTAL A PAGAR", {content: '$' + general.formatNum(elemento.saldoPendiente.toString()), styles: {halign: "right"}}]]

          // doc.autoTable({startY: 150,
          //   // tableLineColor: "white",
          //   // tableLineWidth: 0,
          //   styles: {
          //     // font: 'Calibri',
          //     fontSize: 8,
          //     lineColor: "white",
          //     // lineWidth: 0.1,
          //   },
          //   headStyles: {
          //     fillColor: "white",
          //     textColor: "black",
          //     fontSize: 8
          //   },
          //   bodyStyles: {
          //     fillColor: "white",
          //     textColor: "black",
          //   },
          //   columnStyles: {
          //     1: {halign: "right"}
          //   },
          //   alternateRowStyles: {
          //     fillColor: "white",
          //     textColor: "black",
          //   },
          //   footStyles: {
          //     fillColor: "white",
          //     textColor: "black",
          //     fontSize: 8,
          //     fontStyle: "normal"
          //   },
          //   head: [["CONCEPTO", {content: "VALOR", styles: {halign: "right"}}]],
          //   body: movColecc,
          //   foot: foot,
          //   margin: {top: 0, left: 98, right: 18},
          // })

          // let observFra = ""
          // // if(fraProcFact){
          //   observFra = doc.splitTextToSize("TEVENET NOTICIAS Lunes a Viernes 1 p.m. Canal 2", 180, 2, 2)
          // // }
          // doc.text(observFra, 155, 208.4, 'center')
          // doc.setTextColor("black")
          // doc.setLineWidth(0)

          let imgSourceCB = new Image();
          imgSourceCB.src = codBarras;
          doc.convertStringToImageData(imgSourceCB)
          // 11=Left, 156=Top, 138=Width, 14=Height
          // doc.addImage(imgSourceCB, 'PNG', 11, 156, 138, 14);
          // doc.addImage(imgSourceCB, 'PNG', 11, 148, 138, 24);
          // doc.addImage(imgSourceCB, 'PNG', 71, 210, 138, 24);
          
          doc.addImage(imgSourceCB, 'PNG', 8, 104, 80, 16);
          doc.addImage(imgSourceCB, 'PNG', 8, 262, 80, 16);

          doc.text("Nombre:", 96, 264)
          doc.text(nombreCli, 108, 264)
          doc.text("Dirección:", 96, 268)
          doc.text(linea1DNN, 108, 268)
          doc.text("CEDULA:", 156, 268)
          doc.text(elemento.numeroDoc, 171, 268)
          doc.text("Barrio:", 96, 272)
          doc.text(linea2DNN_B, 108, 272)

          doc.text("CODIGO:", 96, 276)
          doc.text(elemento.contrato, 108, 276)
        
          doc.text("FECHA:", 156, 276)
          doc.text(`PAGO INMEDIATO`, 171, 276)        

          doc.setFontSize(10);
          doc.text('$' + general.formatNum(elemento.saldoPendiente.toString()), 200, 270, 'center')
          doc.setFontSize(7);
        }
        //FIN IMPRIMIR DOCUMENTO DE COBRO MODELO 3 => CABLECAUCA

        if(contList!==listFactCl.length){
          doc.addPage()
        }
      })
      // if(fraProcFact){
      let nameDoc = `doccobro.pdf`
      if(nomB1===nomB2){
        nameDoc = `${nomB1}.pdf`
      }
      doc.autoPrint({variant: 'non-conform'});
      doc.save(nameDoc)
    // }else{
    //   doc.autoPrint({variant: 'non-conform'});
    //   doc.output('dataurlnewwindow'); //abre el pdf en una nueva ventana
    // }
    return(
      <div>

      </div> 
    )
  }

export default ImprDC